import { classNames } from "@punks/ui-core"
import Container from "../Container"
import { ReactNode } from "react"

export type BlockContainerType = "default" | "card"

export type BlockContainerClasses = {
  root?: string
  card?: string
}

export interface BlockContainerProps {
  className?: string
  classes?: BlockContainerClasses
  type?: BlockContainerType
  children?: any
  contentBefore?: ReactNode
  contentAfter?: ReactNode
  noGuttersXs?: boolean
  noGuttersSm?: boolean
  noGuttersMd?: boolean
  noGuttersLg?: boolean
  wide?: boolean
  fluidXs?: boolean
  fluidSm?: boolean
  fluidMd?: boolean
  fluidLg?: boolean
  fluid?: boolean
}

const BlockContainer = ({
  className,
  classes,
  children,
  type,
  contentBefore,
  contentAfter,
  noGuttersXs,
  noGuttersSm,
  noGuttersMd,
  noGuttersLg,
  wide,
  fluidXs,
  fluidSm,
  fluidMd,
  fluidLg,
  fluid,
}: BlockContainerProps) => {
  return (
    <Container
      className={classNames(classes?.root, className)}
      noGuttersXs={noGuttersXs}
      noGuttersSm={noGuttersSm}
      noGuttersMd={noGuttersMd}
      noGuttersLg={noGuttersLg}
      wide={wide}
      fluidXs={fluidXs}
      fluidSm={fluidSm}
      fluidMd={fluidMd}
      fluidLg={fluidLg}
      fluid={fluid}
    >
      {contentBefore}
      {type === "default" && children}
      {type === "card" && (
        <div
          className={classNames(
            "rounded-b-card sm:rounded-card",
            classes?.card
          )}
        >
          {children}
        </div>
      )}
      {contentAfter}
    </Container>
  )
}

export default BlockContainer
